import React, { useState } from 'react';
import { Alert } from 'reactstrap';

const Error = ({ msg }) => {
  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  return (
    <Alert color="alert" isOpen={visible} toggle={onDismiss}>
      {msg}
    </Alert>
  );
};

export default Error;
